import { Routes } from '@angular/router';
import { authCognitoGuard } from 'src/app/auth/auth-cognito.guard';
import { DashboardComponent } from 'src/app/notification/dashboard/dashboard.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { OrgAlertHistoryListComponent } from './org-alert-history-list/org-alert-history-list.component';
import { AlertRosterComponent } from './alert-roster/alert-roster.component';

/** Standalone routes for org landing and patient dashboard. */
export const contactsRoutes: Routes = [
  {
    path: 'contacts',
    pathMatch: 'full',
    component: ContactListComponent,
    canActivate: [authCognitoGuard],
  },
  {
    path: 'alerts',
    pathMatch: 'full',
    component: OrgAlertHistoryListComponent,
    canActivate: [authCognitoGuard],
  },
  {
    path: 'alert-roster',
    pathMatch: 'full',
    component: AlertRosterComponent,
    canActivate: [authCognitoGuard],
  },
  {
    path: 'contact',
    pathMatch: 'full',
    component: DashboardComponent,
    canActivate: [authCognitoGuard],
  },
];
